module.exports = __webpack_public_path__ + "img/pending-filled@2x.ced27a4d.png";